import { render } from "./ClientListItem.vue?vue&type=template&id=43341b03&scoped=true"
import script from "./ClientListItem.vue?vue&type=script&lang=js"
export * from "./ClientListItem.vue?vue&type=script&lang=js"

import "./ClientListItem.vue?vue&type=style&index=0&id=43341b03&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43341b03"]])

export default __exports__